<template>
    <div class="picture_bg">
        <img :src="imgURL" alt="" class="layout_img" ref="photo" ondragstart='return false;'>
    </div>
</template>
<script>

export default({
    created() {
        window.addEventListener('wheel',this.changeSize,false);
        window.addEventListener('mousedown',this.down, false);
        window.addEventListener('mouseup',this.up, false)
    },
    mounted() {
           let index = location.search.indexOf('=');
           this.imgURL = location.search.slice(index + 1);
           this.photo = this.$refs.photo
           this.photo.addEventListener('mousemove', this.move, false)
        },
    beforeUnmount() {
        window.removeEventListener('wheel')
        window.removeEventListener('mousedown')
        window.removeEventListener('mouseup')
        this.photo.removeEventListener('mousemove')
    },
    data() {
        return {
            imgURL : '',
            size : 1,//缩放大小
            newPosition :[],
            oldPosition : [],
            mouseStatus : 'up',
            moveX : 0,
            moveY : 0,
            photo : '',
        }
    },
    methods : {
        changeSize(e) {
            if(e.deltaY < 0) this.size += 0.1;
            else this.size -= 0.1;
            if(this.size < 1) this.size += 0.1;
            this.photo.style= `transform: translate(calc(-50% + ${this.moveX}px),calc(-50% + ${this.moveY}px)) scale(${this.size});transition: all 0.4s;`
        
        },
        down(e) {
            if (e.target == this.photo) {
               this.photo.cursor = 'grabbing'
               this.newPosition = [e.x, e.y]
               this.mouseStatus = 'down';

            }
        },
        up() {
            this.mouseStatus = 'up'
            this.newPosition = []
            this.oldPosition = []
        },
        move(e) {
            if (this.newPosition.length > 0) {
               this.oldPosition = this.newPosition;
               this.newPosition = [e.x, e.y];
               this.moveX = this.moveX + (this.newPosition[0] - this.oldPosition[0]);
               this.moveY = this.moveY + (this.newPosition[1] - this.oldPosition[1]);
            }
            if (this.mouseStatus == 'down') {
                this.photo.style = `transform :translate(calc(-50% + ${this.moveX}px),calc(-50% + ${this.moveY}px)) scale(${this.size});cursor:grabbing`
            } else {
                this.photo.style.cursor = 'grab'
            }
        }
    }
})
</script>

<style scope>
    body {
        margin: 0;
        padding: 0;
        background-color: black !important;
        /* overflow: hidden; */
    }
    .picture_bg {
        background-color: transparent;
        height: 100vh;
        position: relative;
        overflow: hidden;
    }
    .layout_img {
        background-color: #fff;
        position: absolute;
        width: 60%;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        transform-origin: center;
        /* 拖拽样式 */
        user-select: none;
        -webkit-user-drag: none;
    }

</style>
